/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_BackInputs */

const en_apartment_back = /** @type {(inputs: Apartment_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All apartments`)
};

/**
* | output |
* | --- |
* | "All apartments" |
*
* @param {Apartment_BackInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_back = /** @type {((inputs?: Apartment_BackInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_BackInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_back(inputs)
});